import { render, staticRenderFns } from "./examTab.vue?vue&type=template&id=08d14db8&scoped=true"
import script from "./examTab.vue?vue&type=script&lang=js"
export * from "./examTab.vue?vue&type=script&lang=js"
import style0 from "./examTab.vue?vue&type=style&index=0&id=08d14db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d14db8",
  null
  
)

export default component.exports